// src/components/modals/ReactivateSubscriptionModal.tsx

import {
  Button,
  Flex,
  Text,
  DialogRoot,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogCloseTrigger,
  DialogPositioner,
  Portal,
} from '@chakra-ui/react'
import { LuX } from 'react-icons/lu'

type ReactivateSubscriptionModalProps = {
  isOpen: boolean
  onClose: () => void
  onCancel?: () => void // Abbrechen
  onConfirm?: () => Promise<void> | void
}

export function ReactivateSubscriptionModal({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
}: ReactivateSubscriptionModalProps) {
  const handleOpenChange = (details: { open: boolean }) => {
    if (!details.open) {
      onClose()
    }
  }

  const handleCancel = () => {
    onCancel?.()
    onClose()
  }

  const handleConfirm = async () => {
    await onConfirm?.()
    onClose()
  }

  return (
    <DialogRoot open={isOpen} onOpenChange={handleOpenChange} scrollBehavior="inside">
      <Portal>
        <DialogBackdrop />

        <DialogPositioner>
          <DialogContent maxW="420px" position="relative">
            <DialogHeader>
              <DialogTitle>Vertrag reaktivieren</DialogTitle>
            </DialogHeader>

            <DialogCloseTrigger asChild>
              <Button aria-label="Dialog schließen" variant="ghost">
                <LuX />
              </Button>
            </DialogCloseTrigger>

            <DialogBody>
              <Text>
                Läuft der bisherige Vertrag noch, bleibt die bestehende Vertragslaufzeit erhalten.
                Ist der Vertrag bereits abgelaufen, beginnt mit dem heutigen Datum eine neue
                Vertragslaufzeit.
              </Text>

              <DialogFooter>
                <Flex justify="flex-end" gap="3" w="full">
                  <Button variant="outline" onClick={handleCancel}>
                    Abbrechen
                  </Button>
                  <Button colorPalette="blue" onClick={handleConfirm}>
                    Vertrag reaktivieren
                  </Button>
                </Flex>
              </DialogFooter>
            </DialogBody>
          </DialogContent>
        </DialogPositioner>
      </Portal>
    </DialogRoot>
  )
}
